// @ts-nocheck
// ====== Percorso guidato "nuovo cliente" (estratto da clienti.js) ======
// Per un cliente NUOVO mostra i campi a passi (Dati base → Accessi) invece delle
// sette linguette. Usa switchTab (globale, definita in clienti.js) per cambiare
// pannello. Le funzioni sono esposte su globalThis: clienti.js le richiama come
// bare-identifier (stesso schema degli altri moduli UI).

const WIZARD_STEPS = ['anagrafica', 'accessi'];
const WIZARD_LABELS = { anagrafica: 'Dati base', accessi: 'Accessi del team' };
let _wizardOn = false;
let _wizardStep = 0;

function updateWizardUI() {
  const ind = document.getElementById('wizardSteps');
  if (ind) {
    ind.innerHTML = WIZARD_STEPS.map(
      (s, k) =>
        `<span class="wiz-dot ${k === _wizardStep ? 'active' : ''} ${k < _wizardStep ? 'done' : ''}">${k + 1}. ${WIZARD_LABELS[s]}</span>`
    ).join('<span class="wiz-sep">→</span>');
  }
  const last = _wizardStep === WIZARD_STEPS.length - 1;
  document.getElementById('btnWizPrev')?.classList.toggle('hidden', _wizardStep === 0);
  document.getElementById('btnWizNext')?.classList.toggle('hidden', last);
  document.getElementById('btnSaveCliente')?.classList.toggle('hidden', !last);
}

function setupClientWizard(on) {
  _wizardOn = on;
  const modal = document.getElementById('modalCliente');
  if (modal) modal.classList.toggle('modal-wizard', on);
  const ind = document.getElementById('wizardSteps');
  if (!on) {
    ind?.classList.add('hidden');
    document.getElementById('btnWizPrev')?.classList.add('hidden');
    document.getElementById('btnWizNext')?.classList.add('hidden');
    document.getElementById('btnSaveCliente')?.classList.remove('hidden');
    return;
  }
  _wizardStep = 0;
  ind?.classList.remove('hidden');
  if (typeof switchTab === 'function') switchTab(WIZARD_STEPS[0]);
  updateWizardUI();
}

function wizardGo(delta) {
  const n = _wizardStep + delta;
  if (n < 0 || n >= WIZARD_STEPS.length) return;
  _wizardStep = n;
  if (typeof switchTab === 'function') switchTab(WIZARD_STEPS[n]);
  updateWizardUI();
}

// Vero se siamo nel wizard e non ancora all'ultimo passo (usato da clienti.js
// per non salvare se l'utente preme Invio sui passi iniziali).
function isWizardMidStep() {
  return _wizardOn && _wizardStep < WIZARD_STEPS.length - 1;
}

// I pulsanti Indietro/Avanti vivono nel modale cliente (statico in index.html).
document.getElementById('btnWizPrev')?.addEventListener('click', () => wizardGo(-1));
document.getElementById('btnWizNext')?.addEventListener('click', () => wizardGo(1));

Object.assign(globalThis, { setupClientWizard, wizardGo, isWizardMidStep });
export {};
